export default class ContactModel {
    private readonly _displayName: string;
    private readonly _orphyLink: string;
    private readonly _emailAddress: string;

    constructor(displayName: string, orphyLink: string = null, emailAddress: string = null) {
        this._displayName = displayName;
        this._orphyLink = orphyLink;
        this._emailAddress = emailAddress;
    }

    get DisplayName(): string {
        return this._displayName;
    }

    get OrphyLink(): string {
        return this._orphyLink;
    }

    get HasLink(): boolean {
        return !!this.OrphyLink;
    }

    get PreferredEmailAddress(): string {
        return this._emailAddress;
    }

    get HasEmailAddress(): boolean {
        return !!this._emailAddress;
    }

    get MailTo(): string {
        return `mailto:${this._emailAddress}`;
    }
}
